import Vue from 'vue';
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import toastr from "mini-toastr";
toastr.init();

Vue.use(Vuex);


const store =  new Vuex.Store({
    state: {
        dimension: {},
        filter: {},
        menu: {},
        modul: '-',
        redirectPath:'',
        prevRoute: {},
        taskcount: 0,
        user: {},
        timeServer: {},
        notifications: [],
        dashboard: {},
        promocsv: '',
        openOrder: 0,
        soldOut: 0,
        kitchenJob: 0,
        tableUsage: 0,
        progressMigration: {},
        progressMigrationPinjTemp: { status: 'Idle', value:0 },
        progressMigrationPinj: { status: 'Idle', value:0 },
        progressMigrationJmnanTemp: { status: 'Idle', value:0 },
        progressMigrationJmnan: { status: 'Idle', value:0 },
        progressMigrationAngsTemp: { status: 'Idle', value:0 },
        progressMigrationAngs:{ status: 'Idle', value:0 },
        progressMigraPembAngsurTemp: { status: 'Idle', value:0 },
        progressMigraPembAngsuran: { status: 'Idle', value:0 },
        progressMigrationDendaTemp: { status: 'Idle', value:0 },
        progressMigrationDenda: { status: 'Idle', value:0 },
        webloannotification:'',
        curLanguage:'id',
        languages: [
            {
              short: 'en',
              long: 'English'
            },
            {
              short: 'id',
              long: 'Indonesian'
            }
          ]
    },
    mutations: {
        dimension(state, value) {
            state.dimension = value;
        },
        filter(state, value) {
            state.filter = value;
        },
        modul(state, value) {
            state.modul = value;
        },
        redirectPath(state, value) {
            state.redirectPath = value;
        },
        menu(state, value) {
            state.menu = value;
        },
        prevRoute(state, value) {
            state.prevRoute = value;
        },
        taskcount(state, value) {
            state.taskcount = value;
        },
        user(state, value) {
            state.user = value;
        },
        timeServer(state, value) {
            state.timeServer[value.compcode] = value.timeServer;
        },
        webloannotification(state,value){
            state.webloannotification = value;
        },
        notifications(state, value) {
            state.notifications = value;
        },
        dashboard(state, value) {
            state.dashboard = value;
        },
        // punya resto
        promocsv(state, value) {
            state.promocsv = value;
        },
        openOrder(state, value) {
            state.openOrder = value;
        },
        soldOut(state, value) {
            state.soldOut = value;
        },
        kitchenJob(state, value) {
            state.kitchenJob = value;
        },
        tableUsage(state, value) {
            state.tableUsage = value;
        },
        progressMigrationPinjTemp(state, value) {
            state.progressMigrationPinjTemp=value;
        },
        progressMigrationPinj(state, value) {
            state.progressMigrationPinj=value;
        },
        progressMigrationJmnanTemp(state, value) {
            state.progressMigrationJmnanTemp=value;
        },
        progressMigrationJmnan(state, value) {
            state.progressMigrationJmnan=value;
        },
        progressMigrationAngsTemp(state, value) {
            state.progressMigrationAngsTemp = value;
        },
        progressMigrationAngs(state, value) {
            state.progressMigrationAngs = value;
        },
        progressMigraPembAngsurTemp(state, value) {
            state.progressMigraPembAngsurTemp = value;
        },
        progressMigraPembAngsuran(state, value) {
            state.progressMigraPembAngsuran = value;
        },
        progressMigrationDendaTemp(state, value) {
            state.progressMigrationDendaTemp = value;
        },
        progressMigrationDenda(state, value) {
            state.progressMigrationDenda = value;
        },
        translator(state, value) {
            state.translator = value;
        },
    },
    actions: {
        "SOCKET_dashboard"({ commit }, value) {
            commit('dashboard', value);
        },
        //     "SOCKET_restonotification"(state, value) {
        //         // console.log('VUEX ACTION, notificationcounter Update from socket', value);
        //         const myNotif = (value || []).reduce((newArr, item) => {
        //             if ((item.outletid === this.state.user.outletid) && (item.compcode === this.state.user.compcode) && (item.notifName)) {
        //                 newArr.push(item);
        //                 if (item.notifName=='Open Order') this.state.openOrder = item.counter;
        //                 if (item.notifName == 'Kitchen Job') this.state.kitchenJob = item.counter;
        //                 if (item.notifName == 'Table Usage') this.state.tableUsage = item.counter;
        //             }
        //             return newArr;
        //         }, []);
        //         this.state.notifications = myNotif;
        //     },
        // { commit, state }, value
        "SOCKET_progressmigration"({ commit }, obj) {
            commit(obj.key,obj.value);
        },
        // "SOCKET_sendgroupmigrationkey"({commit},value) {
        //     console.log('value',value);
        //     // commit('progressMigration',value);
        //     localStorage.setItem(value.key,value.groupmigrationkey);
        // }

        "SOCKET_progressMigrationAngsTemp"({ commit }, value) {
            // console.log('value',value)
            commit('progressMigrationAngsTemp', value);
        },
        
        "SOCKET_progressMigrationAngs"({ commit }, value) {
            commit('progressMigrationAngs', value);
        },
        "SOCKET_progressMigraPembAngsurTemp"({ commit }, value) {
            // console.log('value',value);
            commit('progressMigraPembAngsurTemp', value);
        },
        "SOCKET_progressMigraPembAngsuran"({ commit }, value) {
            // console.log('value',value);
            commit('progressMigraPembAngsuran', value);
        },
        "SOCKET_timeserver"({ commit }, value) {
            commit('timeServer', value);       
        },
        "SOCKET_webloannotification"({ commit }, value) {
            commit('webloannotification', value.msg);     
        },
        "SOCKET_translator"({ commit }, value) {
            Vue.i18n.add('en', value.en);
            Vue.i18n.add('id', value.id);
            Vue.i18n.set('id');
        },
        
        
    }
})

Vue.use(vuexI18n.plugin, store);

export default store;